import { Button, Dialog } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

interface NavigationPreventionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const NavigationPreventionModal: React.FC<NavigationPreventionModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} hasCloseButton extraClasses="md:w-1/2 md:max-w-1/2">
      <Dialog.Panel>
        <Dialog.Title>{t('enrollments.navigationPreventionModalTitle')}</Dialog.Title>
        <Dialog.Description>{t('enrollments.navigationPreventionModalMessage')}</Dialog.Description>
      </Dialog.Panel>
      <Dialog.Actions>
        <Button label={t('enrollments.exitConfirmationModalGoBack')} extraClasses="w-full" onClick={handleCancel} />
        <Button
          label={t('enrollments.exitConfirmationModalLeavePage')}
          extraClasses="w-full color-white bg-red-900 hover:bg-red-950"
          onClick={handleConfirm}
          primary
        />
      </Dialog.Actions>
    </Dialog>
  );
};

export default NavigationPreventionModal;
